import { PageHeader } from "@primer/react";
import "./PageHeading.css";

export function PageHeading({ actions, children, description, titleLabel }) {
  return (
    <PageHeader className="page-heading" role="banner" aria-label={titleLabel ?? children}>
      <PageHeader.TitleArea><PageHeader.Title className="page-title text-page-title" as="h1">{children}</PageHeader.Title></PageHeader.TitleArea>
      {description ? <PageHeader.Description className="page-description text-body muted-text">{description}</PageHeader.Description> : null}
      {actions ? <PageHeader.Actions>{actions}</PageHeader.Actions> : null}
    </PageHeader>
  );
}
